// import { ChildrenStoreData } from "@parent-app/types";
import { ChildrenStoreData } from "src/shared/types/src";
import { getAxiosInstance } from "../api";

export const fetchAccidentSheet = async ({ child, accidentSheetID }: { child: ChildrenStoreData, accidentSheetID: number }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;

    return retryAxios.get(`/child/${child.childId}/accident-sheet/${accidentSheetID}`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
};

export const fetchAccidentSheetSettings = async ({ child }: { child: ChildrenStoreData }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;

    return retryAxios.get(`/child/${child.childId}/accident-sheet/settings`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
};

export const submitSignature = async ({ child, accidentSheetID, fileName }: { child: ChildrenStoreData, accidentSheetID: number, fileName: string }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;

    return retryAxios.put(`/child/${child.childId}/accident-sheet/${accidentSheetID}/add-signature`, { fileName: fileName }).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
};

export const createAccidentSheetAPI = async ({ child, params }: { child: ChildrenStoreData, params: any }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;

    return retryAxios.post(`/child/${child.childId}/accident-sheet`, params).then((res) => {
        const response = res.data;
        console.log("rseponseData", response)
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
};